import Datadog from "@magalu/ecomm-components/rave/scripts/Datadog";
import useClientEnv from "@magalu/rave/config/useClientEnv";

import packageJson from "../../../package.json";

type Environment = "development" | "staging" | "production";

export default function DatadogInit() {
  const { client } = useClientEnv<{ environment: Environment }>();

  const environment = client.environment;

  if (environment === "development") {
    return null;
  }

  return (
    <Datadog
      applicationId="42d9dfdf-d830-46c4-8e5d-055511be14b7"
      clientToken="pub69c5389a277d736249ea5c3018a49ce7"
      datadogUrl="us5.datadoghq.com"
      service="mixer-web"
      env={environment}
      version={`v${packageJson.version}`}
      sessionSampleRate={3}
      sessionReplaySampleRate={1}
      strategy="beforeInteractive"
      defaultPrivacyLevel="mask-user-input"
      trackLongTasks
      trackResources
      trackUserInteractions
    />
  );
}
